<mat-form-field fxFlex="100">
  <mat-label>{{placeholder}}</mat-label>
  <mat-select multiple [(ngModel)]="selection" (selectionChange)="change.emit(selection)">
    <mat-option *ngFor="let item of data" [value]="item.id">{{item.title | translate}}</mat-option>
  </mat-select>
</mat-form-field>
